module.exports = __webpack_public_path__ + "img/the-red-palace.bd1dbeb9.png";